<template>
  <div class="login-class">
    <el-row>
      <el-col :span="4" class="d-md-down-none">
        <div class="grid-content bg-purple-dark"></div>
      </el-col>
      <el-col :span="16" class="login-links">
        <div style="width: 100%">
          <div style="float:left;height:width:50%;">
            <a :href="base_url" target="_self" class="alink">{{
              $t(language.company_website)
            }}</a>
            <a :href="base_url + locale + '/products'" target="_self" class="alink">{{ $t(language.product) }}</a>
            <a :href="base_url + locale + '/contact-us'" target="_self" class="alink">{{ $t(language.contact) }}</a>
          </div>
          <div style="float: right">
            <b-form inline>
              <el-menu :default-active="locale" class="el-menu-demo" mode="horizontal" text-color="#202020"
                @select="handleSelect">
                <el-submenu index="1">
                  <template slot="title">
                    <i class="iconfont icon-language login-lang-icon"></i><span style="font-size: 14px"
                      class="d-md-down-none">&nbsp;&nbsp;International</span>
                  </template>
                  <el-menu-item index="en"><strong>English</strong></el-menu-item>
                  <!-- <el-menu-item index="sv-se"><strong>Svenska</strong></el-menu-item>
            <el-menu-item index="fi-fi"><strong>Suomeksi</strong></el-menu-item> -->
                  <el-menu-item index="zh-CN"><strong>中文</strong></el-menu-item>
                </el-submenu>
              </el-menu>
              <img src="/logo.png" class="login-logo" />
            </b-form>
          </div>
        </div>
      </el-col>
      <el-col :span="4" class="d-md-down-none">
        <div class="grid-content bg-purple-dark"></div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="login-bg">
          <el-col :span="3" :offset="1" class="d-md-down-none">
            <div class="grid-content"></div>
          </el-col>
          <b-card no-body class="p-2 bg-primary m-0 login-info">
            <b-card-body style="text-align: left;padding: 4px;">
              <span class="login-h" v-if="is_production">{{
                $t(language.login_name)
              }}</span>
              <span class="login-h" v-else>COREUI</span>
              <span class="login-h">{{ test_title }}</span>
              <!-- <p class="text-muted" style="font-size: 1rem; line-height: 1rem">
                {{ $t(language.account_info) }}
              </p> -->
              <el-tabs v-model="activeName" class="login-tabs">
                <el-tab-pane label="微软验证" name="p1">
                  <b-button block variant="primary" class="p-1 iconfont icon-login"
                    style="margin-top: 20px;width:100px;" @click="onToMicrosoftValid" @keyup.enter="onToMicrosoftValid">
                    &nbsp;&nbsp;{{ $t(language.login_label_microsoft) }}</b-button>
                </el-tab-pane>
                <el-tab-pane label="账号密码" name="p2">
                  <b-input-group class="mb-3 login-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-phone"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input name="input_phone" ref="input_phone" autocomplete="off" type="text"
                      class="form-control" style="font-size: 1rem" :placeholder="placePhoneTitle"
                      v-model="loginModel.username" @keydown="inputPhoneKeyDown" />
                  </b-input-group>
                  <b-input-group class="mb-4 login-input-group">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-lock"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input name="input_pwd" ref="input_pwd" autocomplete="off" type="password"
                      class="form-control" style="font-size: 1rem" :placeholder="placePwdTitle"
                      v-model="loginModel.password" @keydown="keyupEnter($event)" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="4">
                      <b-button block variant="primary" class="p-1 iconfont icon-login" @click="onSubmit"
                        @keyup.enter="onSubmit">
                        &nbsp;&nbsp;{{ $t(language.login_label) }}</b-button>
                    </b-col>
                    <b-col cols="4" class="pl-0" v-show="false">
                      <b-button block variant="warning" class="p-1 ml-1" @click="registerAccount">注册</b-button>
                    </b-col>
                    <b-col cols="4" class="text-right mt-2" style="font-size: 14px" v-show="false">
                      <b-link @click="resetPassword">忘记密码？</b-link>
                    </b-col>
                  </b-row>
                </el-tab-pane>

              </el-tabs>

            </b-card-body>
          </b-card>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row style="position: fixed;bottom: 0;width: 100%;"> -->
    <el-row class="footer-link">
      <el-col :span="4" class="d-md-down-none">
        <div class="grid-content bg-purple-dark"></div>
      </el-col>
      <el-col :span="16" class="login-links">
        <h2 class="_2LDS--h2Heading background-before-blue-100">
          {{ $t(language.quick_links) }}
        </h2>
        <ul class="_3Wy7--columnCount3">
          <li class="_20Eh--width3" style="margin-bottom: 0">
            <a class="
                                                _2rl0--root
                                                _2qLO--root
                                                _2Jhy--ctaLink
                                                _1nlS--link
                                                _2qLO--root
                                              " :href="base_url + locale + '/about-stora-enso'"
              :aria-label="$t(language.about_stora_enso)" :title="$t(language.about_stora_enso)" target="_self"
              rel=""><span class="
                                                  zKay--root
                                                  eE0T--iconBefore
                                                  _3fVj--icon
                                                  _2_nP--yellowIcon
                                                " aria-hidden="true"><svg class="_3ipe--arrowHeadRight _1vQq--svg"
                  viewBox="0 0 12 18">
                  <path d="M2 2l6.773 7L2 16"></path>
                </svg></span>{{ $t(language.about_stora_enso) }}</a>
          </li>
          <li class="_20Eh--width3" style="margin-bottom: 0">
            <a class="
                                                _2rl0--root
                                                _2qLO--root
                                                _2Jhy--ctaLink
                                                _1nlS--link
                                                _2qLO--root
                                              "
              href="https://storaenso.sharepoint.com/teams/IT920/Shared%20Documents/Forms/AllItems.aspx?csf=1&web=1&e=taCO0j%2F&RootFolder=%2Fteams%2FIT920%2FShared%20Documents%2FIT%20%E5%9F%B9%E8%AE%AD%E4%B8%AD%E5%BF%83%2FCPSP%E5%9F%B9%E8%AE%AD%E8%B5%84%E6%96%99&FolderCTID=0x012000E6DD5D2EEBB50544B6939092B3658539"
              :aria-label="$t(language.careers)" :title="$t(language.careers)" target="_blank" rel=""><span class="
                                                  zKay--root
                                                  eE0T--iconBefore
                                                  _3fVj--icon
                                                  _2_nP--yellowIcon
                                                " aria-hidden="true"><svg class="_3ipe--arrowHeadRight _1vQq--svg"
                  viewBox="0 0 12 18">
                  <path d="M2 2l6.773 7L2 16"></path>
                </svg></span>{{ $t(language.careers) }}</a>
            <!-- base_url + locale + '/careers' -->
          </li>
          <li class="_20Eh--width3" style="margin-bottom: 0">
            <a class="
                                                _2rl0--root
                                                _2qLO--root
                                                _2Jhy--ctaLink
                                                _1nlS--link
                                                _2qLO--root
                                              " :href="base_url + locale + '/contact-us'"
              :aria-label="$t(language.contact)" :title="$t(language.contact)" target="_self" rel=""><span class="
                                                  zKay--root
                                                  eE0T--iconBefore
                                                  _3fVj--icon
                                                  _2_nP--yellowIcon
                                                " aria-hidden="true"><svg class="_3ipe--arrowHeadRight _1vQq--svg"
                  viewBox="0 0 12 18">
                  <path d="M2 2l6.773 7L2 16"></path>
                </svg></span>{{ $t(language.contact) }}</a>
          </li>
          <li class="_20Eh--width3" style="margin-bottom: 0">
            <a class="
                                                _2rl0--root
                                                _2qLO--root
                                                _2Jhy--ctaLink
                                                _1nlS--link
                                                _2qLO--root
                                              " :href="base_url + locale + '/download-centre'"
              :aria-label="$t(language.download_centre)" :title="$t(language.download_centre)" target="_self"
              rel=""><span class="
                                                  zKay--root
                                                  eE0T--iconBefore
                                                  _3fVj--icon
                                                  _2_nP--yellowIcon
                                                " aria-hidden="true"><svg class="_3ipe--arrowHeadRight _1vQq--svg"
                  viewBox="0 0 12 18">
                  <path d="M2 2l6.773 7L2 16"></path>
                </svg></span>{{ $t(language.download_centre) }}</a>
          </li>
          <li class="_20Eh--width3" style="margin-bottom: 0">
            <a class="
                                                _2rl0--root
                                                _2qLO--root
                                                _2Jhy--ctaLink
                                                _1nlS--link
                                                _2qLO--root
                                              " :href="base_url + locale + '/newsroom'"
              :aria-label="$t(language.newsroom)" :title="$t(language.newsroom)" target="_self" rel=""><span class="
                                                  zKay--root
                                                  eE0T--iconBefore
                                                  _3fVj--icon
                                                  _2_nP--yellowIcon
                                                " aria-hidden="true"><svg class="_3ipe--arrowHeadRight _1vQq--svg"
                  viewBox="0 0 12 18">
                  <path d="M2 2l6.773 7L2 16"></path>
                </svg></span>{{ $t(language.newsroom) }}</a>
          </li>
          <li class="_20Eh--width3" style="margin-bottom: 0">
            <a class="
                                                _2rl0--root
                                                _2qLO--root
                                                _2Jhy--ctaLink
                                                _1nlS--link
                                                _2qLO--root
                                              " :href="base_url + locale + '/sustainability'"
              :aria-label="$t(language.sustainability)" :title="$t(language.sustainability)" target="_self" rel=""><span
                class="
                                                  zKay--root
                                                  eE0T--iconBefore
                                                  _3fVj--icon
                                                  _2_nP--yellowIcon
                                                " aria-hidden="true"><svg class="_3ipe--arrowHeadRight _1vQq--svg"
                  viewBox="0 0 12 18">
                  <path d="M2 2l6.773 7L2 16"></path>
                </svg></span>{{ $t(language.sustainability) }}</a>
          </li>
        </ul>
      </el-col>
      <el-col :span="4" class="d-md-down-none">
        <div class="grid-content bg-purple-dark"></div>
      </el-col>
    </el-row>
    <el-row class="login-footer">
      <el-col :span="4">
        <div class="grid-content bg-purple-dark" style="background-color: #f8f8f9"></div>
      </el-col>
      <el-col :span="16" style="padding-top: 6px;">
        <!-- <div
          style="width:300px;margin:0 auto; padding:20px 0;"

        >
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13028302000150"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
            ><img src="../../../public/img/police.png" style="float:left;" />
            <p
              style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
            >
              冀公网安备 13028302000150号
            </p></a
          >
        </div> -->
        <strong style="
                                            float: left;
                                            height: 20px;
                                            line-height: 20px;
                                            margin: 0px 0px 0px 5px;
                                            color: #939393;
                                          ">
          Copyright © {{ plantSetting.copy_right }}
        </strong>
        <strong style="
                                            float: left;
                                            height: 20px;
                                            line-height: 20px;
                                            margin: 0px 0px 0px 5px;
                                            color: #939393;
                                          " v-if="is_production">&nbsp; Stora Enso &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #939393">冀ICP备06025035号-2</a></strong>
        <strong style="
                                            float: left;
                                            height: 20px;
                                            line-height: 20px;
                                            margin: 0px 0px 0px 5px;
                                            color: #939393;
                                          " v-if="is_production">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13028302000150" style="
                                              display: inline-block;
                                              text-decoration: none;
                                              height: 20px;
                                              line-height: 20px;
                                            "><img src="../../../public/img/police.png" style="float: left" />
            <p style="
                                                float: left;
                                                height: 20px;
                                                line-height: 20px;
                                                margin: 0px 0px 0px 5px;
                                                color: #939393;
                                              ">
              冀公网安备 13028302000150号
            </p>
          </a>
        </strong>
        <strong style="
                                            float: left;
                                            height: 20px;
                                            line-height: 20px;
                                            margin: 0px 0px 0px 5px;
                                            color: #939393;
                                          " class="ml-4"><span v-if="is_production">CPSP &nbsp;</span>
          Version {{ plantSetting.version }}</strong>
        <!-- <strong> Copyright © {{ plantSetting.copy_right }} </strong>
        <strong v-if="is_production">&nbsp; Stora Enso &nbsp;&nbsp;&nbsp;&nbsp; <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#212529">冀ICP备06025035号-2</a></strong>
        <strong style="float:right"><span v-if="is_production">CPSP &nbsp;</span> Version {{ plantSetting.version }}</strong> -->
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple-dark" style="background-color: #f8f8f9"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import jwtDecode from "jwt-decode"
// -- import * as _ from "lodash-es"
import * as api from "../../shared/api"
import apiPath from "../../shared/apiPath"
import language from "../../shared/language"
import * as localStorageMgr from "../../shared/localStorageMgr"
import plantSetting from "../../shared/plant_setting"
import * as sessionStorageMgr from "../../shared/sessionStorageMgr"

export default {
  name: "Login",
  data() {
    return {
      is_production: true,
      plantSetting: plantSetting,
      logobg_style:
        "background: url(/img/dashbord-bg.jpg) no-repeat; background-size: 100% !important;",
      loginModel: {
        username: "",
        password: "",
      },
      language: language.login,
      locale: "zh-CN",
      base_url: "https://www.storaenso.com/",
      lang_data: {},
      placePhoneTitle: "用户名",
      placePwdTitle: "密码",
      test_title: "",
      activeName: 'p1'
    }
  },
  beforeCreate() {
    localStorage.removeItem(localStorageMgr.data.plant_idx)
    localStorage.removeItem(localStorageMgr.data.access_token)
    sessionStorage.removeItem(sessionStorageMgr.data.cpsp_store)
  },
  watch: {
    "$route": {
      handler(val) {
        if (val && val.query.j && val.query.j !== '') {
          console.log(val)
          this.successLogin(val.query.j)
        }
      },
      deep: true
      // immediate: true
    },
  },
  async created() {

    let _last_account = localStorageMgr.get(
      localStorageMgr.data.last_login_account
    )
    if (_last_account && _.isString(_last_account)) {
      this.loginModel.username = _last_account
      this.loginModel.password = ""
    } else {
      this.loginModel.username = ""
      this.loginModel.password = ""
    }
    if (localStorageMgr.get(localStorageMgr.data.locale)) {
      this.locale = localStorageMgr.get(localStorageMgr.data.locale)
    }

    await this.$loadLanguageAsync(this.locale, this.$i18n)
    this.localLangSet()

  },

  mounted() {
    this.is_production = !this.$store.state.is_production
    // this.$refs.input_phone.focus();
    if (apiConfig.env === "development") {
      this.test_title = " - 测试"
    }
    if (this.$route.query && this.$route.query.url && this.$route.query.url.indexOf('?j=') > -1) {
      this.successLogin(this.$route.query.url.split('?j=')[1])
    }
  },
  methods: {
    async onToMicrosoftValid() {
      let rt = await api.query_async({
        url: apiPath.user.login_uri,
        parameters: null,
        method: "get",
      })
      if (
        rt &&
        rt[0].result &&
        rt[0].result.data
      ) {
        window.open(decodeURIComponent(rt[0].result.data.url), '_self')
      }
    },
    async handleSelect(key, keyPath) {
      this.locale = key
      localStorageMgr.set(localStorageMgr.data.locale, key)
      // window.history.go(0);
      await this.$loadLanguageAsync(this.locale, this.$i18n)
      this.localLangSet()
    },
    localLangSet() {
      if (this.locale == "en") {
        this.placePhoneTitle = "username"
        this.placePwdTitle = "password"
      } else {
        this.placePhoneTitle = "用户名"
        this.placePwdTitle = "密码"
      }
    },
    keyupEnter(e) {
      if (e.keyCode === 13) {
        if (this.loginModel.password == "" || this.loginModel.username == "") {
          this.msgToasts("手机号，密码不能为空!", "info")
        } else {
          this.onSubmit()
        }
      }
    },
    inputPhoneKeyDown(e) {
      if (e.keyCode === 13) {
        this.$refs.input_pwd.focus()
      }
    },
    //从云端读取设置并加载到本地
    getSettingFromCloud() {
      this.$api.apiGetSetting(null).then((data) => {
        if (data) {
          let selectColHeader = data.selectColHeader
          let allhearder = data.allhearder
          let store = data.store
          let default_value_setting = data.default_value_setting
          let favoriteMenu = data.menu
          if (favoriteMenu == undefined) {
            favoriteMenu = "[]"
          }
          localStorage.setItem("selectColHeader", selectColHeader)
          localStorage.setItem("allhearder", allhearder)
          localStorage.setItem("store", store)
          localStorage.setItem("favoriteMenu", favoriteMenu)
          if (default_value_setting) {
            localStorage.setItem(
              "default_value_setting",
              JSON.stringify(default_value_setting)
            )
          }
          window.location.href = "/"
        } else {
          window.location.href = "/"
        }
      })
    },
    registerAccount() {
      window.location.href = "/pages/Register"
      //this.$router.push({ path: "/pages/Register" });
    },
    resetPassword() {
      window.location.href = "/pages/resetPassword"
    },
    async onSubmit() {
      let _this = this
      let _errorMsg = ""
      this.loginModel.username = _.trim(this.loginModel.username)
      if (this.loginModel.username == "" || this.loginModel.password == "") {
        this.msgToasts("手机号，密码不能为空!", "info")
      } else {
        let _p = new FormData()
        _p.append("username", this.loginModel.username)
        _p.append("password", this.loginModel.password)
        let login_result = await api.query_async({
          url: apiPath.user.login,
          parameters: _p,
          method: "post",
        })
        console.log(login_result)
        if (
          login_result &&
          login_result[0].result &&
          login_result[0].result.data.valid
        ) {
          this.successLogin(login_result[0].result.data.jwt)
        } else {
          _errorMsg = "用户或密码无效"
        }
        if (_errorMsg != "") {
          _this.msgToasts(_errorMsg, "error")
        }
      }
    },
    successLogin(jwt) {
      ///token 及 access_token
      this.ls.set(
        localStorageMgr.data.access_token,
        jwt
      )

      //平台设置信息
      // await this.getPlantSetting()
      //用户信息
      // {"nbf":1621127135,"exp":1623719135,"iat":1621127135,"data":{"id":2}}

      let login_rt = jwtDecode(jwt)
      let _user_id = login_rt.data.id
      this.$store.commit("init_biz_data", {
        content_path: "biz_data",
        content_type: "userInfo",
        data: {
          user_id: _user_id,
          local_username: this.loginModel.username,
        },
      })
      // ======await this.getUserInfo(user_idx)
      localStorage.setItem("theme", "gray")
      localStorageMgr.set(localStorageMgr.data.last_login_account, this.loginModel.username)
      if (this.$route.query && this.$route.query.url && this.$route.query.url.indexOf('?j=') > -1) {
        window.location.href = "/"
      }
      else if (window.location.href.indexOf("?url=") > -1) {
        window.location.href = decodeURIComponent(
          window.location.href.split("?url=")[1]
        )
      } else {
        window.location.href = "/"
      }
    },
    async getPlantSetting() {
      ///获取公共信息保存到localStorage,code:"_cpsp_Setting"
      let plant_setting = await api.query_async({
        url: apiPath.common.get_setting,
        parameters: null,
        method: "get",
      })
      if (plant_setting) {
        this.$store.commit("init_biz_data", {
          content_path: "biz_data",
          content_type: "plantSetting",
          data: plant_setting[0].result.data,
        })
      }
    },
    async getUserInfo(user_idx) {
      let user_info_result = await api.query_async({
        url: apiPath.user.get_userinfo,
        parameters: user_idx,
        method: "get",
      })
      if (
        user_info_result &&
        user_info_result[0] &&
        user_info_result[0].result
      ) {
        let _user_info = user_info_result[0].result.data.user

        this.$store.commit("init_biz_data", {
          content_path: "biz_data",
          content_type: "userInfo",
          data: _user_info,
        })
      }
    },
  },
}
</script>

<style>
@media (max-width: 600px) {
  .el-menu-demo {
    margin-right: 0.8rem;
  }

  .login-logo {
    width: auto;
    height: 30px;
  }

  .login-h {
    color: #202020;
    font-size: 1.2rem;
    font-weight: 700;
  }

  .login-bg {
    height: 250px;
    padding-top: 5rem;
    text-align: center;
    background: url("/login-bg.jpg") no-repeat;
    background-size: 100% auto;
  }

  .login-info {
    height: 250px;
    width: 23rem;
    margin: 3.5rem auto !important;
  }

  .login-lang-icon {
    font-size: 1rem;
    margin-top: 0.5rem;
  }

  .text-muted {
    line-height: 0.2rem !important;
  }

  .login-input-group {
    margin-bottom: 0.5rem !important;
  }

  .login-links {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    width: 100%;
    /* margin-top: 6rem; */
  }

  .el-row {
    margin-bottom: 20px;
    line-height: 60px;
    background-color: #fff;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #fff;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .alink {
    color: #202020;
    font-size: 0.95rem;
    font-weight: 700;
    border-bottom: 3px solid #fdc80a;
    padding-bottom: 3px;
    text-decoration: none;
    margin: 0 10px;
  }

  .alink:hover {
    color: #2020205e;
  }

  .login-class .el-menu.el-menu--horizontal {
    border-bottom: none;
    height: 60px;
  }

  .login-class .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 60px;
    line-height: 60px;
    border-bottom: 2px solid transparent;
    color: #202020;
    font-size: 10px;
    font-weight: 700;
    padding: 0;
  }

  .login-class .el-menu--horizontal:hover {
    color: blue;
  }

  .login-class a {
    color: inherit;
    text-decoration: none;
  }

  .login-class .el-row {
    margin-bottom: 0;
  }

  ._2LDS--h2Heading {
    color: #202020;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.6rem;
    padding: 0 0 0 23px;
    position: relative;
    margin: 0 0 20px;
    width: 100%;
  }

  ._2LDS--h2Heading:before {
    background-color: #118bd6;
    content: "";
    display: inline-block;
    height: 100%;
    left: 0;
    position: absolute;
    width: 5px;
  }

  ._3Wy7--columnCount3 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
  }

  ._20Eh--width3 {
    flex: 0 1 31%;
    min-width: 0;
    line-height: 1.8rem;
  }

  ._2Jhy--ctaLink {
    display: flex;
    flex: 1;
    font-weight: 700;
    font-size: 16px;
    margin: 0 0 5px;
  }

  ._2rl0--root {
    text-decoration: none;
  }

  ._1nlS--link {
    align-items: center;
    display: flex;
  }

  ._2qLO--root {
    text-decoration: none;
  }

  .zKay--root {
    display: inline-block;
    height: 15px;
    width: 15px;
  }

  .eE0T--iconBefore {
    margin: -2px 7px 0 0;
  }

  ._2_nP--yellowIcon {
    stroke: #fdc80a;
  }

  ._3fVj--icon {
    fill: none;
    line-height: 0;
    stroke: #fdc80a;
    stroke-width: 2;
    vertical-align: middle;
  }

  ._3ipe--arrowHeadRight {
    stroke-width: 4;
  }

  ._1vQq--svg {
    display: inline-block;
    height: inherit;
    speak: none;
    width: inherit;
  }

  .footer-link {
    margin-top: 150px;
    width: 100%;
    /* position: fixed; */
    bottom: 0;
  }

  .login-footer {
    width: 100%;
    background-color: #f8f8f9;
    line-height: 60px;
    margin-top: 20px;
    padding-left: 15px;
    /* position: fixed; */
    bottom: 0;
  }

  .login-tabs {
    margin-top: -30px !important;
  }

  .login-tabs .el-tabs__header {
    line-height: 20px;
    margin: 5px;
  }
}

@media (min-width: 600px) {
  .login-logo {
    width: auto;
    height: 60px;
    margin-left: 1rem;
  }

  .login-h {
    color: #202020;
    font-size: 1.5rem;
    font-weight: 700;
  }

  .text-muted {
    line-height: 0rem !important;
  }

  .login-bg {
    height: 500px;
    padding-top: 5rem;
    background: url("/login-bg.jpg") no-repeat;
    background-size: 100% auto;
  }

  .login-info {
    height: 300px;
    width: 450px;
  }

  .el-row {
    margin-bottom: 20px;
    line-height: 80px;
    background-color: #fff;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #fff;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  /* .login-class {
  font-size: 16px;
  font-weight: 700;
} */
  /* .login-class .el-menu.el-menu--horizontal {
  border-bottom: none;
}
.login-class .el-menu .el-menu-item {
  float: left;
  height: 60px;
  line-height: 80px;
  margin: 0;
  border-bottom: 3px solid #fdc80a;
  color: #202020;
  font-size: 16px;
  font-weight: 700;
} */
  .alink {
    color: #202020;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 3px solid #fdc80a;
    padding-bottom: 3px;
    text-decoration: none;
    margin: 0 20px;
  }

  .alink:hover {
    color: #2020205e;
  }

  .login-class .el-menu.el-menu--horizontal {
    border-bottom: none;
    height: 80px;
  }

  .login-class .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 80px;
    line-height: 80px;
    border-bottom: 2px solid transparent;
    color: #202020;
    font-size: 10px;
    font-weight: 700;
    padding: 0;
  }

  .login-class .el-menu--horizontal:hover {
    color: blue;
  }

  .login-class a {
    color: inherit;
    text-decoration: none;
  }

  .login-class .el-row {
    margin-bottom: 0;
  }

  ._2LDS--h2Heading {
    color: #202020;
    font-size: 28px;
    font-weight: 700;
    line-height: 32px;
    padding: 0 0 0 23px;
    position: relative;
    margin: 0 0 20px;
    width: 100%;
  }

  ._2LDS--h2Heading:before {
    background-color: #118bd6;
    content: "";
    display: inline-block;
    height: 100%;
    left: 0;
    position: absolute;
    width: 5px;
  }

  ._3Wy7--columnCount3 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
  }

  ._20Eh--width3 {
    flex: 0 1 31%;
    min-width: 0;
    line-height: 3rem;
  }

  ._2Jhy--ctaLink {
    display: flex;
    flex: 1;
    font-weight: 700;
    font-size: 16px;
    margin: 0 0 5px;
  }

  ._2rl0--root {
    text-decoration: none;
  }

  ._1nlS--link {
    align-items: center;
    display: flex;
  }

  ._2qLO--root {
    text-decoration: none;
  }

  .zKay--root {
    display: inline-block;
    height: 15px;
    width: 15px;
  }

  .eE0T--iconBefore {
    margin: -2px 7px 0 0;
  }

  ._2_nP--yellowIcon {
    stroke: #fdc80a;
  }

  ._3fVj--icon {
    fill: none;
    line-height: 0;
    stroke: #fdc80a;
    stroke-width: 2;
    vertical-align: middle;
  }

  ._3ipe--arrowHeadRight {
    stroke-width: 4;
  }

  ._1vQq--svg {
    display: inline-block;
    height: inherit;
    speak: none;
    width: inherit;
  }

  .footer-link {
    margin-top: 0px;
    width: 100%;
  }

  .login-footer {
    width: 100%;
    background-color: #f8f8f9;
    line-height: 60px;
    margin-top: 0px;
  }

  .login-tabs {
    margin-top: -30px !important;
  }

  .login-tabs .el-tabs__header {
    line-height: 20px;
    margin: 5px;
  }
}

@media (min-height: 900px) {
  .footer-link {
    margin-top: 150px;
    width: 100%;
  }

  .login-footer {
    width: 100%;
    background-color: #f8f8f9;
    line-height: 60px;
    margin-top: 0px;
    position: fixed;
    bottom: 0;
  }

  .login-tabs {
    margin-top: -30px !important;
  }

  .login-tabs .el-tabs__header {
    line-height: 20px;
    margin: 5px;
  }
}
</style>
